import type { BlueprintConfig } from '@cobliteam/blueprint-react-renderer';
import { Location } from '@cobliteam/common-types';

const routeRegistry: BlueprintConfig['navigation']['routeRegistry'] = {
  'cobli:alerts': Location.ALERTS_TRIGGERS,
  'cobli:alerts.create': Location.ALERTS_BLUEPRINT_CREATE,
  'cobli:alerts.legacy.create': Location.ALERTS_TRIGGERS_CREATE,
  'cobli:alerts.activationHistory': Location.ALERTS_TYPE,
  'cobli:alerts.edit': Location.ALERTS_TRIGGERS_EDIT,
  'cobli:vehicle.track': Location.TRACKING,
};
export { routeRegistry };
